import 'is-in-viewport';

const animateInViewportClasses = [
	'move-up-in-viewport',
	'move-down-in-viewport',
	'move-left-in-viewport',
	'move-right-in-viewport',
	'fade-in-in-viewport',
	'zoom-in-in-viewport',
	'active-in-viewport',
	'full-width-in-viewport',
	'animate-in-in-viewport',
	'slide-in-in-viewport',
];

let didScroll = false;
let scrollTimeout;
let windowHeight;

$( function() {
	windowHeight = $( window ).height();

	animateInViewport();
	updateStyle();
} );

$( window ).scroll( function() {
	if ( !scrollTimeout ) {
		scrollTimeout = setTimeout( function() {
			animateInViewport();
			didScroll = true;
			scrollTimeout = null; // Reset timeout
			updateStyle();
		}, 100 ); // Delay in milliseconds
	}
} );

$( window ).resize( function() {
	windowHeight = $( window ).height();
} );

function updateStyle() {
	const $blocks = $( '[class*="styled-block"]' );

	let tallestBlock = null;
	$blocks.each( function() {
		const $this = $( this );
		const height = getHeightInViewport( $this );
		if ( !tallestBlock || height > tallestBlock.height ) {
			tallestBlock = {
				element: $this,
				height,
			};
		}
	} );

	if ( tallestBlock ) {
		if ( tallestBlock.element.attr( 'data-style' ) ) {
			$( 'body' ).removeClass( function( index, className ) {
					return (className.match( /(^|\s)style-\S+/g ) || []).join( ' ' );
			} );

			if ( !$( 'body' ).hasClass( 'footer-visible' ) ) {
				$( 'body' ).addClass( 'style-' + tallestBlock.element.attr( 'data-style' ) );
			}

			$( '.history' )
				.not( tallestBlock.element.find( '.history' ) )
				.removeClass( '!pointer-events-auto !opacity-100 visible-history' );
		}
		if ( $( 'body' ).hasClass( 'footer-visible' ) ) {
			$( 'body' ).addClass( 'style-' + $( '.site-footer' ).attr( 'data-style' ) );
		}
	}

	const $properties = $( '.property' );
	let tallestProperty = null;
	$properties.each( function( index ) {
		const $this = $( this );
		const height = getHeightInViewport( $this );
		if ( !tallestProperty || height > tallestProperty.height ) {
			tallestProperty = {
				index,
				element: $this,
				height,
			};
		}
	} );

	if ( tallestProperty ) {
		$( '.dot' ).each( function( index ) {
			$( this ).toggleClass( 'active', tallestProperty.index === index );
		} );
		$( '.property-carousel-container' ).each( function( index ) {
			const $this = $( this );
			$this.toggleClass( 'opacity-0', tallestProperty.index !== index );
			$.makeArray( $this, $this.find( '.carousel-previous,.carousel-next' ) ).each( function() {
				this.style.setProperty( 'pointer-events', (tallestProperty.index === index) ? 'auto' : 'none', 'important' );
			} );
		} );
	}

	animateInViewport();
}

export function animateInViewport() {
	$( animateInViewportClasses.map( cls => `.${cls}` ).join( ',' ) ).filter( ':not(.wait-to-animate)' ).each( function() {
		const $this = $( this );

		if ( $this.is( ':in-viewport' ) ) {
			$this.addClass( 'active' );
		}
	} );
}

function getHeightInViewport( $el ) {
	var elementHeight = $el.outerHeight(),
		H = windowHeight,
		r = $el[ 0 ].getBoundingClientRect(),
		t = r.top,
		b = r.bottom;
	return Math.max( 0, t > 0 ? Math.min( elementHeight, H - t ) : Math.min( b, H ) );
}

let isFooterDisabled = false;
let isFooterTemporarilyDisabled = false;

function showFooter() {
	if ( isFooterDisabled ) {
		return;
	}

	$( 'body' ).addClass( 'footer-visible' );
	if ( isOnBottomOfSite() ) {
		$( '#content' ).css( { 'transform': `translateY(calc(-${Math.ceil( $( '.site-footer' ).outerHeight() )}px + 160px))` } );
	} else {
		$( '#content' ).css( { 'transform': `translateY(-${Math.ceil( $( '.site-footer' ).outerHeight() )}px)` } );
	}
	$( '.site-footer' ).css( {
		'transform': 'translateY(0)',
		'opacity': '1',
	} );

	isFooterTemporarilyDisabled = true;
	window.scrollBy( 0, 2 );
	setTimeout( updateStyle, 100 );
	setTimeout( function() {
		isFooterTemporarilyDisabled = false;
		updateStyle();
	}, 500 );
}

function hideFooter() {
	if ( isFooterDisabled || isFooterTemporarilyDisabled ) {
		return;
	}

	$( 'body' ).removeClass( 'footer-visible' );
	$( '#content' ).css( { 'transform': '' } );
	$( '.site-footer' ).css( {
		'transform': '',
		'opacity': '0',
	} );
	updateStyle();
	setTimeout( updateStyle, 410 );
}

function toggleFooter() {
	if ( $( 'body' ).hasClass( 'footer-visible' ) ) {
		hideFooter();
	} else {
		showFooter();
	}
}

$( updateFooterBehavior );
$( window ).scroll( function() {
	if ( isOnBottomOfSite() ) {
		showFooter();
	} else {
		hideFooter();
	}
} );
$( window ).resize( updateFooterBehavior );

function updateFooterBehavior() {
	if ( shouldUseStaticFooter() ) {
		isFooterDisabled = true;
		$( '#content' ).css( { paddingBottom: '' } );
		$( '.site-footer' )
			.removeClass( 'fixed' )
			.css( {
				'transform': 'translateY(0)',
				'opacity': '1',
			} );
		animateInViewport();
		setTimeout( animateInViewport, 410 );
	} else {
		isFooterDisabled = false;
		$( '#content' ).css( { paddingBottom: '160px' } );
		$( '.site-footer' ).addClass( 'fixed' );
		hideFooter();
	}
}

$( 'a[href$="#kontakt"]' ).each( function() {
	const $this = $( this );
	$this.click( function( event ) {
		event.preventDefault();
		toggleFooter();
	} );
} );

$( '#content' ).click( function( event ) {
	hideFooter();
} );

function isOnBottomOfSite() {
	return Math.ceil( window.innerHeight + window.scrollY ) + 2 >= document.body.scrollHeight;
}

function shouldUseStaticFooter() {
	return $( '#content' ).height() < $( window ).height() - 10
		|| $( '.site-footer' ).outerHeight() > $( window ).height() - 10;
}